import React from 'react';
import './Splash.css';
import SplashBG from './../../../Assets/homebanner.svg';
import {Link} from "react-router-dom";

const Splash = props => {
    return (
        <div id="splash-container">
            <div className="splash-bg">
                <img src={SplashBG} alt="splash-bg" />
            </div>
            <div id="splash-intro">
                <div className="splash-intro-heading">
                    Our Enterprise, Our Solution
                </div>
                <div className="splash-intro-heading">
                    Your Success
                </div>
                <hr className="hr hr-splash"/>
                <div id="splash-content">
                    Audigo provides Accuracy, Clarity, Consistency and Commitment of Hi-tech finance and accounting services; adaptive business support services and agile people practices.
                    {/*<br/><br />*/}
                    {/*You run your Business, We’ll do support to achieve your success.*/}
                </div>
                <a href="https://forms.gle/2itxQL3W6DPE8Sxp8" target="_blank">
                    <div className="splash-button">
                        Start a Free Trail
                    </div>
                </a>
            </div>
        </div>
    );
};

export default Splash;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/Splash/Splash.js